﻿let RegularBaseHubDisconnect: boolean = false;
let tryingToReconnect: boolean = false;
let ReconnectCount: number = 0;
let MaxReconnectCount: number = 3;

namespace WebPortal.Hub {
    export class BaseHub {
        constructor() {
            this.initBaseHub();
        }

        protected HubObj: any;

        public WebPortalHub(): any {
            return this.HubObj;
        }

        public initBaseHub(): void {
            console.info("WebPortalHub - create hub");
            this.HubObj = $.connection.WebPortalHub;
            $.connection.hub.qs = { "UserIdent": $("#hdf_se_request_param").val() };

            // this function is executed when the state of the connection changes
            $.connection.hub.stateChanged((state: SignalR.StateChanged) => {
                let stateConversion: string[] = ["connecting", "connected", "reconnecting", "", "disconnected"];
                console.info("SignalR state changed from: " + stateConversion[state.oldState] + " to: " + stateConversion[state.newState]);

                // childs informieren, dass der Hub verbunden ist
                if (state.newState === $.signalR.connectionState.connected) {
                    this.isconnected();
                }
            });

            // this function is executed when the connection is slow
            $.connection.hub.connectionSlow(() => {
                let reconnectCause = "We are currently experiencing difficulties with the connection.";
                console.warn('SignalR ConnectionSlow - ' + reconnectCause);
                // Show_Status_Message_Cause("Connection slow", reconnectCause, true);
            });

            $.connection.hub.reconnecting(() => {
                tryingToReconnect = true;
                let reconnectCause = "We are currently experiencing difficulties with the connection.<br />We try an automatic reconnection attempt.<br />If this message is turned off then please press F5 to restore the session or wait a while.";
                if (Misc.isRmsClient()) {
                    reconnectCause = "We are currently experiencing difficulties with the connection.<br />We try an automatic reconnection attempt.<br />If this message is turned off then please press ctrl + r to restore the session or wait a while.";
                }
                console.warn('SignalR Reconnecting - ' + reconnectCause);
                Show_Status_Message_Cause("Reconnecting", reconnectCause, false);
            });

            $.connection.hub.reconnected(() => {
                tryingToReconnect = false;
                ReconnectCount = 0;
                console.info('SignalR Reconnected');
                Close_Status_Message();
            });

            // Information about Lifetime Events
            // https://docs.microsoft.com/en-us/aspnet/signalr/overview/guide-to-the-api/handling-connection-lifetime-events
            $.connection.hub.disconnected(function () {
                console.error("SignalR Disconnected");
                if ($.connection.hub.lastError) { console.error("Disconnected Reason: " + $.connection.hub.lastError.message); }

                if (!RegularBaseHubDisconnect && !tryingToReconnect) {
                    if (ReconnectCount < MaxReconnectCount) {
                        ReconnectCount++;
                        console.error("SignalR Reconnect in 1 Second");
                        setTimeout(function () {
                            $.connection.hub.start();
                        }, 1000);
                    } else {
                        try {
                            this.onConnectionInterrupted();
                        } catch (exc) {
                            console.error(exc.message);
                        }
                    }
                }
            });

            // this function is executed when an error occurs
            $.connection.hub.error((error: SignalR.ConnectionError) => {
                console.error("SignalR error: " + error);
                this.onConnectionInterrupted();
            });

            try {
                // start the connection.
                $.connection.hub.logging = true;
                $.connection.hub.start({ transport: ["webSockets", "serverSentEvents", "longPolling"] })
                    .done(() => {
                        console.log("Connected, transport = " + $.connection.hub.transport.name);
                    })
                    .fail(() => {
                        console.error("Could not Connect!");
                        this.onConnectionInterrupted();
                    });
            } catch (exc) {
                console.error(exc.message);
            };

            this.HubObj.client.ShowException = (_Cause: string) => {
                Show_Status_Message_Cause("Error", _Cause, false);
            };

            this.HubObj.client.ShowCause = (_Title: string, _Cause: string, _ShowClose: boolean) => {
                Show_Status_Message_Cause(_Title, _Cause, _ShowClose);
            };

            this.HubObj.client.ShowMessage = (_Cause: string) => {
                console.log(_Cause);
                //if (!isRDPConnectionStarted) {
                Show_Status_Message({ title: "Status", message: _Cause, progress: true });
                //  }
            };

            this.HubObj.client.ShowStatusInfo = (_Tag: string, _Cause: any, _Timeout: any = 5000, _WithBackgroundBlur: any = false) => {
                navigationMessage.show(_Tag, _Cause, _Timeout, _WithBackgroundBlur);
            };

            this.HubObj.client.ShowStatusMessageInConsole = (_Cause: string) => {
                console.info(_Cause);
            };

            this.HubObj.client.PrepareMessageUpdate = (_MessageProviderObj: any) => {
                MessageProviderObj = _MessageProviderObj;
                notificationCenter.PrepareNotificationCenter()
                notification.showNotifcationPopup();
            };

            this.HubObj.client.BackendInitialized = () => {
                console.info("Backend Initialized (Session Verified), start KeepAlive Timer");
                // aktualisiert die MasterSession beim AuthenticationManager (alle 30 Sekunden - eine Sek in Ausführung)
                SessionKeepAliveTimerVar = setInterval(() => onSessionKeepAliveTimer(), 29000);
                // Aktionen, welche nach einer sauberen Initialisierung durchgeführt werden sollen (z.B. Session verbinden)
                this.onInitializedBackend();
            }

            this.HubObj.client.OnRefreshSessionResponse = (_ResultState: boolean) => {
                console.debug("Refresh Session Response - ResultState: " + _ResultState);
                if (_ResultState) {
                    SessionKeepAliveCount = SessionKeepAliveCountMax;
                }
            }

            // Der WebServer hat SessionEnd getriggert. Die Seite wird entladen
            this.HubObj.client.StopConnectionOnSessionEnd = () => {
                console.error("The Session on the WebServer has ended, the Page will be unloaded");
                ActualPage.PageUnLoad();

                setTimeout(() => {
                    Show_Status_Message_Cause("Web Server Session ended", "The Session on the Web Server has ended, the Page will be unloaded. Please restart for future work.", false);
                }, 500);
            };

            // parameter
            this.HubObj.state.ResolutionWidth = screen.width;
            this.HubObj.state.ResolutionHeight = screen.height;
            this.HubObj.state.sender_url = window.location.hostname + " - " + window.location.pathname;
            // weitere Parameter deklaration "LocalIpAddress" in Main.ts (muss verzögert gesetzt werden können)
        }

        protected isconnected(): void {
            console.info("SignalR ist connected");

            // Erst alle Status Messages schliessen, wenn der Status TryingToReconnect ist.
            // Damit wird verhindert, dass im Session Join die Statusmeldung nicht zu früh geschlossen wird (REMAS-2495)
            if (tryingToReconnect) {
                console.info("Closing possible status message");
                Close_Status_Message();
            }
            let code = Misc.getUrlParameter("code");
            let state = Misc.getUrlParameter("state");

            if (code && state) {
                console.info("doOidbLoginWithAuthManager");
                this.HubObj.server.doOidbLoginWithAuthManager(code, state);
            }

            if (!LoginRequired) {
                let requestParam: string = $("#hdf_se_request_param").val();
                if (!!requestParam) {
                    if (FirstHubConnecting) {
                        console.info("doInitializeBackend");
                        this.HubObj.server.doInitializeBackend(requestParam);
                    }
                } else {
                    console.error("Error, no Request String found!");
                }
            }
        }

        protected onInitializedBackend(): void {
            console.info("onInitializedBackend");
        }

        // Wird auch aufgerufen, wenn das Netzwerk kurz unterbricht z.B. von Kabel auf WLAN
        protected onConnectionInterrupted(): void {
            console.error("onConnectionInterrupted");
            if (!RegularBaseHubDisconnect) {
                if (Misc.isRmsClient()) {
                    Show_Status_Message_Cause("Connection Error", "The connection to RMS was interrupted.<br />Please press ctrl + r to restore the Session or restart RMS", false);
                } else {
                    Show_Status_Message_Cause("Connection Error", "The connection to RMS was interrupted.<br />Please press F5 to restore the Session or restart RMS", false);
                }
            }
        }
    }
}